import { combineReducers } from "redux";
import log from "loglevel";
import { reducer as toastrReducer } from "react-redux-toastr";
import * as r from "./reducers";
import { LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS } from "store/actions";

const combinedReducers = combineReducers({
  login: r.loginReducer,
  logout: r.logoutReducer,
  jwt: r.jwtReducer,

  authyRegister: r.authyRegisterReducer,
  authyVerify: r.authyVerifyReducer,
  authyOtp: r.authyOtpReducer,

  resetAuth: r.resetAuthReducer,
  resetPhone: r.resetPhoneReducer,
  createPasswordNoAuth: r.createPasswordNoAuthReducer,

  account: r.accountReducer,
  accounts: r.accountsReducer,
  accountUser: r.accountUserReducer,
  accountUsers: r.accountUsersReducer,
  isCurrentUserAccountOwner: r.currentUserAccountOwnerReducer,

  analysis: r.analysisReducer,
  analyses: r.analysesReducer,
  analysisTeam: r.analysisTeamReducer,
  analysisTeams: r.analysisTeamsReducer,

  team: r.teamReducer,
  teams: r.teamsReducer,
  teamUser: r.teamUserReducer,
  teamUsers: r.teamUsersReducer,

  user: r.userReducer,
  users: r.usersReducer,
  currentUser: r.currentUserReducer,
  currentUserChangePassword: r.currentUserChangePasswordReducer,

  role: r.roleReducer,
  roles: r.rolesReducer,
  permission: r.permissionReducer,
  permissions: r.permissionsReducer,
  rolePermission: r.rolePermissionReducer,
  rolePermissions: r.rolePermissionsReducer,

  config: r.configReducer,
  configOp: r.configOpReducer,
  configs: r.configsReducer, // overrides
  configDefault: r.configDefaultReducer, // default from *.conf load

  externalLink: r.externalLinkReducer,
  externalLinks: r.externalLinksReducer,
  externalLinkOp: r.externalLinkOpReducer,

  aboutMicroservice: r.aboutMicroserviceReducer,
  aboutMicroservices: r.aboutMicroservicesReducer,
  aboutMicroserviceOp: r.aboutMicroserviceOpReducer,

  alerts: r.alertsReducer,

  globalMessage: r.globalMessageReducer,

  kibana: r.kibanaReducer,
  logstashPipelines: r.logstashPipelinesReducer,
  logstashPipelineStats: r.logstashPipelineStatsReducer,

  toastr: toastrReducer, // <- Mounted at toastr

  // YardSight-specific Reducers
  ymsDeckingOptTester: r.ymsDeckingOptTesterReducer,
  ymsDeckingFilter: r.ymsDeckingFilterReducer,
});

const rootReducer = (state: any, action: any) => {
  if ([LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS].includes(action.type)) {
    log.info("Resetting state...");
    state = undefined;
  }
  return combinedReducers(state, action);
};

export default rootReducer;
